import React from 'react';

const Features = () => {
  const features = [
    {
      title: "Pure Extract Powders",
      description: "We use only concentrated mushroom extract powders, not ground mycelium or fruiting bodies. This extraction process maximizes bioavailability of beta-glucans and beneficial compounds."
    },
    {
      title: "Sustainably Wildcrafted",
      description: "Sourced from the pristine forests of the Kootenays in British Columbia. We practice responsible wildcrafting and cultivation that respects forest ecology and promotes regeneration."
    },
    {
      title: "Tradition Meets Science",
      description: "Our formulations honor centuries of traditional mushroom medicine while backed by modern mycological research. Each species is selected for its specific wellness benefits."
    }
  ];

  return (
    <section className="features">
      <div className="feature-columns">
        {features.map((feature, index) => (
          <div key={index} className="feature-col">
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
